import { InformationCircleIcon } from '@heroicons/react/24/solid';
import './ModalOpenIcon.scss';

type Props = {
  modalId: string;
};

function ModalOpenIcon(props: Props) {
  const { modalId } = props;
  return (
    <span className="configurator__modal-open-icon" data-toggle="modal" data-target={`#${modalId}`}>
      <InformationCircleIcon className="info-icon" />
    </span>
  );
}

export default ModalOpenIcon;
